import styled from "styled-components";

const BACKGROUND_GIF =
  "https://spirit-prod-assets.s3.amazonaws.com/wavylines.gif";

export const BackGroundAnimation = styled.div`
  position: fixed;
  inset: 0;
  background-color: #120818;
  background-image: url(${BACKGROUND_GIF});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  image-rendering: auto;
`;
